import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  menuLink: {
    color: theme.palette.colors.text,
    textDecoration: 'none',
  },
  optionInput: {
    color: '#000',
  },
  popover: {
    display: 'flex',
    flexDirection: 'column',
    width: '260px',
  },
}));

export default useStyles;
